import { FormattedMessage } from 'react-intl'
import { useRouter } from 'solito/router'

import Stack, { StackProps } from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import Badge from 'app/features/Blog/components/Badge'
import { OptionModel } from 'app/hooks/useOptions'

interface ArticleAssociatedTagsProps {
  tags: OptionModel[]
  sx?: StackProps['sx']
}

const ArticleAssociatedTags: RFC<ArticleAssociatedTagsProps> = ({
  tags,
  sx
}) => {
  const router = useRouter()
  const handleTagClick = (tag: string) => router.push(`/blog/search-by/${tag}`)

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: 2.25,
        position: 'relative',
        ...sx
      }}
    >
      <Text
        variant="body2"
        sx={{ color: 'text.third', alignSelf: 'flex-start' }}
      >
        <FormattedMessage defaultMessage="Tags" />
      </Text>

      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: 1,
          flexWrap: 'wrap',
          rowGap: 1
        }}
      >
        {tags.map(({ label, value }) => (
          <Badge
            onClick={handleTagClick}
            key={value}
            label={label}
            value={value}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default ArticleAssociatedTags
